export default "__VITE_ASSET__o17elaNQ__"